import {
  SCOPE_3_CATEGORIES_STEPS
} from "../../../../../SupplierQuestionnaire/components/Revenue/components/ScopeThree/const";
import { ScopeThreeQuestions } from "./AggregatedSuppliersData/ScopeThreeQuestions";
import { MissingDataLabel } from "../../../../components/MissingDataLabel";
import { Card } from "../../../../../../components/Card";
import React from "react";
import { useGetAggregatedSuppliersDataReport } from "../../../../../../hooks/query/reports";
import { useToast } from "@chakra-ui/react";
import { showErrorToast } from "../../../../../../utils";

function AggregatedScopeThreeQuestions({ selectedYear, selectedQuarter, handleExportClick }) {
  const toast = useToast();
  const handleErrors = (err) => {
    if (err.response?.status === 404) {
      return;
    }
    showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message);
  };

  const {
    data: aggregatedData
  } = useGetAggregatedSuppliersDataReport({
    year: selectedYear,
    quarter: selectedQuarter
  }, {
    onError: err => handleErrors(err),
    refetchOnWindowFocus: false,
    cacheTime: 0
  });

  // We are checking for an answer in the first category, because if an answer for any category is saved
  // then answers of all categories are auto saved at that time as well.
  return (
    <Card boxShadow="xs">
      {aggregatedData && aggregatedData.scopeThree && aggregatedData.scopeThree[SCOPE_3_CATEGORIES_STEPS[0]] &&
      aggregatedData.scopeThree[SCOPE_3_CATEGORIES_STEPS[0]].calculationMethods.length > 0 ?
        <ScopeThreeQuestions data={aggregatedData.scopeThree} handleExportClick={handleExportClick} /> :
        <MissingDataLabel />
      }
    </Card>
  );
}

export default AggregatedScopeThreeQuestions;